import React, {useEffect, useState} from "react";
import {gql} from "@apollo/client";
import {useQuery} from "@apollo/client";
import {useAuthStore} from "../../store/useAuthStore";
import {getAccessKey} from "../../util/secureAuthStorage";

export const GET_MY_INFO = gql`
  query getMyAccountInfos {
    seeMe {
      id
      login_type
      username
      nickname
      access_token
      nickname
      following_count
      follower_count
      bio
      resizedSmallImage
      resizedBigImage
      email
      phone
      gender
      createdAt
      updatedAt
      isBusiness
      seller {
        id
        income
        rating
        sold_count
        fee
        is_certified
        feeWavedUntil
        is_tester
        seller_account {
          bank_name
          account_holder_name
          bank_account
        }
      }
    }
  }
`;

export default function AutoLogin() {
    const {setUser, login} = useAuthStore();
    const [hasAccessToken, setHasAccessToken] = useState('');
    const {
        data: { seeMe: myInfoData = {} } = {},
    } = useQuery(GET_MY_INFO, {skip: !hasAccessToken});

    useEffect(() => {
        if (myInfoData?.id) {
            setUser(myInfoData);
            login(myInfoData);
        }
    }, [myInfoData]);

    useEffect(() => {
        const token = getAccessKey();
        if (token !== null) {
            setHasAccessToken(token);
        }
    }, []);

    return <></>
}
